import iconGradient from '../assets/icon-gradient.png';

export default function SplashScreen({ isLeaving = false }) {
  return (
    <section
      aria-label="Afroawi"
      className={`fixed inset-0 z-[9999] flex min-h-screen items-center justify-center bg-white transition-opacity duration-200 ${
        isLeaving ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <img src={iconGradient} alt="Afroawi" className="h-16 w-auto" />
    </section>
  );
}
